import React from 'react';
import { WebsiteDesignProps } from './types';
import { Flower2, Coffee, Sun } from 'lucide-react';
import { Button } from "@/components/ui/button";

const GardenParty: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Rosewood Conservatory";

    return (
        <div className="bg-[#fffbf0] text-[#5e6c5b] min-h-screen font-serif">
             {/* Floral Pattern (simulated) */}
             <div className="fixed inset-0 pointer-events-none opacity-5" style={{backgroundImage: 'radial-gradient(#ffb7b2 2px, transparent 2px)', backgroundSize: '30px 30px'}}></div>

             <nav className="p-8 flex justify-center items-center relative z-20">
                 <div className="bg-white px-12 py-6 rounded-full shadow-[0_4px_20px_rgba(0,0,0,0.05)] border border-[#e8dfc5] flex items-center gap-4">
                     <Flower2 className="text-[#ffb7b2]" />
                     <span className="text-xl font-bold tracking-widest uppercase text-[#8a9a88]">{schoolName}</span>
                     <Flower2 className="text-[#ffb7b2]" />
                 </div>
             </nav>

             <main className="container mx-auto px-8 py-12 relative z-10 text-center">
                 <div className="max-w-3xl mx-auto border-2 border-[#e8dfc5] p-2 rounded-t-[10rem] rounded-b-2xl bg-white/50 backdrop-blur-sm shadow-sm">
                     <div className="border border-[#e8dfc5] px-12 py-24 rounded-t-[9.5rem] rounded-b-xl bg-white">
                         <div className="inline-block p-4 rounded-full bg-[#f4f9f4] mb-8">
                             <Sun className="text-[#ffb7b2]" />
                         </div>
                         <h1 className="text-5xl md:text-7xl font-light text-[#5e6c5b] mb-8 leading-tight">
                             Class & <br/> <span className="text-[#ffb7b2] font-normal italic">Cultivation</span>
                         </h1>
                         <p className="text-lg text-[#8a9a88] leading-relaxed mb-12 max-w-lg mx-auto">
                             A refined environment for blooming minds. We nurture intellect with the same care one tends to a prize garden.
                         </p>
                         <Button className="bg-[#8a9a88] hover:bg-[#788a76] text-white rounded-full px-10 py-6 text-sm uppercase tracking-widest shadow-md hover:shadow-lg transition-all">
                             Request Invitation
                         </Button>
                     </div>
                 </div>

                 <div className="mt-16 flex justify-center gap-12 font-sans text-xs font-bold text-[#8a9a88] uppercase tracking-widest">
                     <div className="flex flex-col items-center gap-2">
                         <div className="w-24 h-32 bg-[#fff0f5] rounded-t-full border border-[#ffe4e1] mb-2 overflow-hidden relative">
                             <img src="https://images.unsplash.com/photo-1510832198491-a941c4747343?q=80&w=1974&auto=format&fit=crop" className="w-full h-full object-cover opacity-80" alt="Flowers" />
                         </div>
                         <span>Etiquette</span>
                     </div>
                     <div className="flex flex-col items-center gap-2 pt-12">
                         <div className="w-24 h-32 bg-[#f0fff4] rounded-t-full border border-[#f0fff4] mb-2 overflow-hidden relative">
                             <img src="https://images.unsplash.com/photo-1542601906990-24ccd08d7455?q=80&w=1965&auto=format&fit=crop" className="w-full h-full object-cover opacity-80" alt="Tea" />
                         </div>
                         <span>Arts</span>
                     </div>
                     <div className="flex flex-col items-center gap-2">
                         <div className="w-24 h-32 bg-[#fffbf0] rounded-t-full border border-[#fffbf0] mb-2 overflow-hidden relative">
                             <img src="https://images.unsplash.com/photo-1507643179173-617d654f9229?q=80&w=1974&auto=format&fit=crop" className="w-full h-full object-cover opacity-80" alt="Garden" />
                         </div>
                         <span>Botany</span>
                     </div>
                 </div>
            </main>
        </div>
    );
};

export default GardenParty;
